import { Controller } from '@hotwired/stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['fileName', 'loadingText', 'fileCsv','errorMessage']
  static values = { validateCsvUrl: String }

  onChangeFileUserCsv(event) {
    this.loadingTextTarget.innerText = '...uploading'
    this.fileNameTarget.innerText = event.target.files[0].name
    this.errorMessageTarget.innerText = ''

    const formData = new FormData()
    formData.append("corporation[file]", event.target.files[0])

    Rails.ajax({
      url: this.validateCsvUrlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        // handle response
        this.loadingTextTarget.innerText = ''
        if(response.success === false){
          this.errorMessageTarget.innerText = 'エラーが発生しました。' + response.error
        }
      },
      error: (response) => {
        this.loadingTextTarget.innerText = 'エラーが発生しました。'
      }
    });
  }

  onClickFileUserCsv(event) {
    event.stopPropagation()
    this.fileCsvTarget.value = null
  }
}
